import FAQSection from './FAQ/FAQ';
import RefundPolicySection from './RefundPolicy/RefundPolicy';
import HighlightsSection from './Highlights/Highlights';
import type { GoodToKnowProps } from '../types';
import type { Section } from './Section';

export const getSectionsInOrder = ({ faqs, highlights, refundPolicy }: GoodToKnowProps) => {
  const sections: Section[] = [];
  if (highlights) {
    sections.push(HighlightsSection(highlights));
  }

  if (refundPolicy) {
    sections.push(RefundPolicySection(refundPolicy));
  }

  faqs?.forEach((faq) => {
    sections.push(FAQSection(faq));
  });

  return sections;
};
